import { get } from 'aws-amplify/api';
import { PRESCRIPTSURE } from '../constants/api-endpoints';
import { getSessionToken } from './service-config';

const apiNamePath = PRESCRIPTSURE.USER_API;
const NPI_API_VERSION = '2.1';

const npiGet = async (queryParams) => {
  let headers = {};
  try {
    const token = await getSessionToken();
    headers = { Authorization: `Bearer ${token}` };
  } catch {
    // No session (e.g. registration flow) — call backend without auth header.
    // Requires the /npi_api API Gateway resource to allow unauthenticated access.
  }

  const op = get({
    apiName: apiNamePath,
    path: '/npi_api',
    options: { headers, queryParams },
  });

  return (await op.response).body.json();
};

const searchByNumber = async (number) => {
  return npiGet({ version: NPI_API_VERSION, number });
};

const searchByName = async (firstName, lastName = '') => {
  const queryParams = { version: NPI_API_VERSION, first_name: firstName };
  if (lastName.length >= 2) {
    queryParams.last_name = `${lastName}*`;
  }
  return npiGet(queryParams);
};

/**
 * Format NPI provider data for display
 * @param {Object} result - Raw API result
 * @returns {Object} - Formatted provider data
 */
const formatNPIProvider = (result) => {
  const { number, basic } = result;
  const { first_name, last_name, middle_name, name_prefix, credential } = basic;

  const displayName = `${name_prefix ? `${name_prefix} ` : ''}${first_name}${
    middle_name ? ` ${middle_name}` : ''
  } ${last_name}${credential ? `, ${credential}` : ''}`;

  return {
    value: number,
    label: `${displayName} (NPI: ${number})`,
    npi: number,
    firstName: first_name,
    lastName: last_name,
    middleName: middle_name,
    prefix: name_prefix,
    credential,
    addresses: result.addresses,
    taxonomies: result.taxonomies,
    fullName: displayName,
  };
};

export const npiService = {
  searchByNumber,
  searchByName,
  formatNPIProvider,
};
